import store from '@/stores/store';
import { ModuleContext } from '@/stores/moduleConst';
import commonFn from '@/commons/commonFunction';

class AuthService {
  /**
   * Kiểm tra xem còn session đăng nhập ko
   */
  isAuthenticated() {
    const context = store.state[ModuleContext];
    if (context.Token) {
      let expired = context.TokenExpired;
      if (expired && expired > new Date()) {
        return true;
      }
    }
    return false;
  }

  /**
   * xử lý login qua misaid
   * hàm này sẽ build link ra redirect qua trang misaid để login
   */
  login(callbackUrl) {
    location.href = '/login';
    return;

    //build ra url gọi sang trang của misaid
    var state = new Date().getTime();
    if (callbackUrl) {
      state += '|' + callbackUrl;
    }

    let redirectUrl = window._misaId
      .getUrl('loginUrl')
      .replace('{state}', state);

    location.href = redirectUrl;
  }
}

export default new AuthService();
